import * as React from "react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, IconButton } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import { useMutation, useQuery } from "react-query";
import {
  GetSupplierNoticeSummary,
  UpdateSupplierNoticePin,
  UpdateSupplierNoticeViewDate,
} from "../../services/SupplierNotice.service";
import {
  noticeSummaryResponse,
  updateSupplierNoticePinRequest,
} from "../../models/SupplierNotice.model";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useDispatch } from "react-redux";
import { setNoticeSummary } from "../../redux/summaryCount/summaryCountAction";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Item = styled(Paper)(() => ({
  backgroundColor: "#fff",
  textAlign: "center",
}));
export default function ModalNotice({
  openModel,
  setOpenModal,
  detail,
  FNsetPinColor,
  FNsetViewDate,
  isLogin,
}: any) {
  const [open, setOpen] = React.useState(openModel);
  const [pinColor, setPinColor] = React.useState(detail.isPinned);
  //=========redux for call summary api

  const dispatch = useDispatch();

  const UpdateSupplierNoticeViewDateMutation = useMutation(
    UpdateSupplierNoticeViewDate,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          if (FNsetViewDate !== null) {
            FNsetViewDate();
          }
          // getSupplierNoticeSummaryMutate.mutate();
        }
      },
    }
  );
  const getSupplierNoticeSummaryMutate = useMutation(GetSupplierNoticeSummary, {
    onSuccess: (data: noticeSummaryResponse) => {
      // setCount(data.count);
      // setHasInstant(data.hasInstant);
      dispatch(
        setNoticeSummary({ count: data.count, hasInstant: data.hasInstant })
      );
    },
  });
  //=========redux for call summary api

  React.useEffect(() => {
    if (!detail.supplierViewDate && openModel && isLogin === false) {
      UpdateSupplierNoticeViewDateMutation.mutateAsync({
        noticeKey: detail.noticeKey,
      });
    }
    setOpen(openModel);
    setPinColor(detail.isPinned);
  }, [openModel]);
  const handleClose = () => {
    setOpen(false);
    setOpenModal(false);
  };
  // React.useEffect(() => {

  // }, [openModel]);
  const updatePin = new updateSupplierNoticePinRequest();
  const handlePin = (noticeId: any) => {
    updatePin.noticeKey = noticeId;
    updatePin.isPinned = !detail.isPinned;
    UpdateSupplierNoticePinMutation.mutateAsync(updatePin);
  };
  const UpdateSupplierNoticePinMutation = useMutation(UpdateSupplierNoticePin, {
    onSuccess: (data: boolean) => {
      if (data) {
        setPinColor(!pinColor);
        if (FNsetPinColor !== null) {
          FNsetPinColor(!pinColor);
        }
      }
    },
  });
  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            borderRadius: "6px",
            width: "60%",
            border: "solid 3px #DAE0E4",
            outline: 0,
          }}
          className="  "
        >
          <IconButton onClick={handleClose}>
            <CloseIcon
              style={{
                position: "fixed",
                zIndex: "1",
                left: "1vh",
                color: "red",
                top: "1vh",
              }}
            />
          </IconButton>
          {/* <Grid xs={12} sm={12} md={12} lg={2} textAlign={'center'} >
                            {card === "" ? "" : }
                    </Grid> */}
          <Grid container spacing={2}>
            <Grid container xs={12} className="ActivePlansCardContainer">
              <Grid item xs={2} md={1}>
                <span style={{ color: "#9AAFC4" }}>عنوان اطلاعیه: &nbsp;</span>{" "}
              </Grid>
              <Grid item xs={6} md={7}>
                <b className="colorTitle" style={{ textAlign: "right" }}>
                  {" "}
                  {detail.title}{" "}
                </b>
              </Grid>
              <Grid item xs={4} md={4} style={{ textAlign: "left" }}>
                <span
                  className={
                    detail.noticeType == "Instant"
                      ? "colorImportantOld"
                      : "colorInfoOld"
                  }
                >
                  {detail.noticeTypePersian} -&nbsp;{" "}
                  <span
                    style={{
                      color: "#424242",
                      direction: "ltr",
                      display: "inline-block",
                    }}
                  >
                    {detail.creationDatePersian}
                  </span>
                </span>
                {!isLogin ? (
                  <span
                    onClick={() => handlePin(detail.noticeKey)}
                    className="cursorPointer"
                    style={{ marginRight: "15px" }}
                  >
                    {// detail.isPinned == true ||
                    pinColor ? (
                      <span>
                        {" "}
                        <PushPinIcon
                          className={
                            detail.noticeType == "Instant"
                              ? "colorImportantOld"
                              : "colorInfoOld"
                          }
                        />
                      </span>
                    ) : detail.isPinned == false ? (
                      <span>
                        <PushPinOutlinedIcon style={{ color: "#9AAFC4" }} />
                      </span>
                    ) : (
                      <span>
                        <PushPinOutlinedIcon style={{ color: "#9AAFC4" }} />
                      </span>
                    )}
                  </span>
                ) : null}
              </Grid>
            </Grid>
            <Grid container xs={12}>
              <Grid item xs={2} md={1}></Grid>
              <Grid
                item
                xs={10}
                md={11}
                style={{
                  textAlign: "right",
                  paddingTop: "2vh",
                  whiteSpace: "break-spaces",
                  // lineHeight: "40px",
                }}
              >
                <span dangerouslySetInnerHTML={{ __html: detail.body }}></span>
                {/* {detail.body} */}
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                style={{
                  textAlign: "left",
                  color: "#004BFE",
                  paddingBottom: "2vh",
                }}
              >
                {" "}
                {detail.expirationDatePersian ? (
                  <span>
                    {" "}
                    &nbsp;تاریخ انقضاء:{" "}
                    <span>{detail.expirationDatePersian}</span>
                    &nbsp;
                  </span>
                ) : null}{" "}
              </Grid>
            </Grid>
            {detail.attachments ? (
              <Grid
                container
                xs={12}
                style={{
                  paddingTop: "15px",
                }}
              >
                <Grid item xs={2} md={1} style={{ paddingTop: "3vh" }}>
                  <span
                    style={{
                      marginBottom: "5px",
                      color: "#9AAFC4",
                      paddingTop: "5px",
                    }}
                  >
                    {" "}
                    ضمیمه شده: &nbsp;
                  </span>
                </Grid>
                <Grid
                  item
                  xs={10}
                  md={11}
                  style={{
                    textAlign: "right",
                    paddingRight: "2vh",
                    borderTop: "2px solid #edefef",
                  }}
                >
                  <br />

                  {detail.attachments?.map((item: any) => (
                    <a
                      href={item?.fileUrl!}
                      target="_blank"
                      className="cursorPointer"
                    >
                      {item?.fileType == "Image" ? (
                        <img
                          className="activePlansCardImg"
                          src={`${item.fileUrl}`}
                          alt=""
                        />
                      ) : (
                        <span
                          className="ImageIconNotice "
                          style={{
                            padding: "1vh",
                            // width: "inherit !important",
                          }}
                        >
                          <InsertDriveFileOutlinedIcon className="uploadImageIcon jusfityImage" />
                        </span>
                      )}
                    </a>
                  ))}
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
